import {
   MultiSelect as MantineMultiSelect,
   MultiSelectProps as MantineMultiSelectProps,
} from '@mantine/core'
import styles from './MultiSelect.module.scss'
import cn from 'classnames'

export const MultiSelect = ({
   checkIconPosition = 'right',
   classNames: externalClassNames,
   nothingFoundMessage = 'No results found',
   ...props
}: MantineMultiSelectProps) => {
   return (
      <MantineMultiSelect
         nothingFoundMessage={nothingFoundMessage}
         checkIconPosition={checkIconPosition}
         classNames={{
            input: cn(styles['text-input'], (externalClassNames as any)?.input),
            label: cn('text-white/90 font-medium mb-1.5', (externalClassNames as any)?.label),
            dropdown: cn('bg-black rounded-lg p-2', (externalClassNames as any)?.dropdown),
            description: cn('pt-0.5', (externalClassNames as any)?.description),
            pill: cn(styles['pill'], 'rounded-md border border-[#9F7BFF]/40 text-xs bg-[rgba(159,123,255,0.20)] flex items-center leading-none', (externalClassNames as any)?.pill),
         }}
         inputWrapperOrder={['label', 'input', 'description', 'error']}
         {...props}
      />
   )
}
